import { Navigate, Outlet } from 'react-router';

import { useSession } from '@/features/auth/useSession';
import { featuresOf, type Features } from '@/shared/session/currentUser';
import { Spinner } from '@/shared/ui/Spinner';

/**
 * Guard for a screen that only exists when a module of fase 2 is switched on
 * (`Features`, ADR 0016 of the back). Off is not a permission problem, it is the screen
 * not existing yet: sent to the inbox exactly like an unknown route, not shown a refusal.
 *
 * It hangs inside `RequireAuth`, so by the time it runs there is a session; what it adds
 * is the flag. **A convenience, not the control**: the API answers 404 to the module's
 * endpoints whatever this component does.
 */
export function RequireFeature({ feature }: { feature: keyof Features }) {
  const session = useSession();

  if (session.isPending) {
    return <Spinner variant="fill" label="Comprobando lo disponible" />;
  }

  if (!featuresOf(session.data)[feature]) {
    return <Navigate to="/correos" replace />;
  }

  return <Outlet />;
}
